export const aboutData = {
    title: "Who I am",
    description1: "My name is Mrutyunjaya Sahoo. I'm a front-end webdeveloper",
    description2: "I love programming and enjoy learning by doing. I'm excited to grow and be a helpful part of any team.",
    image: 2
}